import React from 'react';
import './footer.scss';
import './footer-mobile.scss';

function Footer() {
  return (
    <section id="content-footer">
      <section className="footer-links">
        <button
          type="button"
          data-toggle="modal"
          data-target="#modal-termos-de-uso"
          className="buttons-transparent"
        >
          <span>
            Termos de Uso
          </span>
        </button>
        <button
          type="button"
          data-toggle="modal"
          data-target="#modal-politica-de-privacidade"
          className="buttons-transparent"
        >
          <span>
            Politica de Privacidade
          </span>
        </button>
        <button
          type="button"
          data-toggle="modal"
          data-target="#modal-suporte"
          className="buttons-transparent"
        >
          <span>
            Suporte
          </span>
        </button>
      </section>
      <section className="Copyright">
        <span>Copyright ⓒ 2021 AGSAFE</span>
      </section>
    </section>
  );
}

export default Footer;
